import { type BuildEnvironment } from './build-environment';
import { BASE_ENVIRONMENT } from './environment.base';
import { createApiUrl } from './utils/create-api-url';

/**
 * The second development deployment. It is a developer-facing environment like `dev`, so it
 * keeps `BASE_ENVIRONMENT`'s `local` deployment target and only swaps in its own hosts.
 */
export const environment: BuildEnvironment = {
  ...BASE_ENVIRONMENT,
  apiUrl: createApiUrl('https://core.devthesecond-blaze.tech'),
  mediaCdnUrl: 'https://app.devthesecond-blaze.tech',
  schemaValidation: true,
  websocketsUrl: createApiUrl('wss://core.devthesecond-blaze.tech'),
};
